module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/_a-function.js
// module id = 611
// module chunks = 0